import React, { useEffect, useState } from 'react';

import { alpha, styled } from '@mui/material/styles';

import { TINY_MARGIN_PX } from '~/theme';

const AnimatedTyping = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setCount((c) => (c >= 2 ? 0 : c + 1)), 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <Wrapper>
      {new Array(3).fill(null).map((_, index) => (
        <Dot key={index} active={index === count} />
      ))}
    </Wrapper>
  );
};

export default AnimatedTyping;

const Wrapper = styled('span')`
  display: flex;
  align-items: flex-end;
  height: 24px;
  gap: ${TINY_MARGIN_PX};
  box-sizing: border-box;
`;
const Dot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>`
  display: block;
  width: 10px;
  min-width: 10px;
  height: 10px;
  border-radius: 50%;
  transition: 0.8s background-color;
  background: ${({ theme, active }) => alpha(theme.palette.common.white, active ? 0.33 : 0.13)};
`;
